#import "../fragments/user-email-fragment.graphql"

mutation AttemptToVerifySmtpConnection($userEmailId: ID!) {
    smtpConnectionAttemptToVerify(input: {userEmailId: $userEmailId}) {
        userEmail {
            ...UserEmail
        }
    }
}
